const CHARSETS = {
    alphanumeric: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    'url-safe':   'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~',
};

type Charset = keyof typeof CHARSETS;

interface RandomOptions {
    length: number;
    charset: Charset;
}

export function randomString({ length, charset }: RandomOptions): string {
    const characters = CHARSETS[charset];

    const randomValues = new Uint32Array(length);
    window.crypto.getRandomValues(randomValues);

    let result = '';

    for (let i = 0; i < length; i++) {
        result += characters.charAt(randomValues[i] % characters.length);
    }

    return result;
}
